export enum Cultures {
  'en-US' = 'en-US',
  'nl-NL' = 'nl-NL',
}

export enum ButtonVariants {
  Primary = 'primary',
  Secondary = 'secondary',
  Text = 'text',
  TextNoPadding = 'textNoPadding',
  ContactLinks = 'contactlinks',
}

export enum MediaTypes {
  Image = 'imageComponent',
  Video = 'videoComponent',
  Embed = 'embedVideoComponent',
}

export enum ButtonSizes {
  Small = 'small',
  Large = 'large',
}

export enum RichTextAlignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

export enum CardTypes {
  Default = 'default',
  Person = 'person',
  FundsAndMandates = 'fundsAndMandates',
  Facts = 'facts',
  Header = 'header',
  Publication = 'publication',
}

export enum MediaContentTypes {
  Image = 'imageComponent',
  Video = 'videoComponent',
  Embed = 'embedVideoComponent',
}

export enum ContactLinkTypes {
  Linkedin = 'linkedin',
  Facebook = 'facebook',
  Twitter = 'twitter',
  Youtube = 'youtube',
  Phone = 'phone',
  Email = 'email',
}

export enum GridColumns {
  One = 'one',
  Two = 'two',
  Three = 'three',
}

export enum ContactLinkVariants {
  Linkedin = 'linkedin',
  Facebook = 'facebook',
  Twitter = 'twitter',
  Youtube = 'youtube',
  Phone = 'phone',
  Email = 'email',
}
export enum ImageTextAlignment {
  Left = 'left',
  Right = 'right',
}

export enum PageTypes {
  HomePage = 'homePage',
  ContentPage = 'contentPage',
  SearchPage = 'searchPage',
  SubHomePage = 'subHomePage',
  FundsMandatesOverviewPage = 'fundsMandatesOverviewPage',
  PortfolioOverviewPage = 'portfolioOverviewPage',
  PublicationOverviewPage = 'publicationOverviewPage',
  FundsMandatesDetailPage = 'fundsMandatesDetailPage',
  FundsDetailPage = 'fundsDetailPageV2',
  PortfolioDetailPage = 'portfolioDetailPage',
  PublicationDetailPage = 'publicationDetailPage',
}

export enum SearchCategories {
  HomePage = 'homePage',
  ContentPage = 'contentPage',
  SearchPage = 'searchPage',
  SubHomePage = 'subHomePage',
  FundsMandatesOverviewPage = 'fundsMandatesOverviewPage',
  PortfolioOverviewPage = 'portfolioOverviewPage',
  PublicationOverviewPage = 'publicationOverviewPage',
  FundsMandatesDetailPage = 'fundsMandatesDetailPage',
  PortfolioDetailPage = 'portfolioDetailPage',
  PublicationDetailPage = 'publicationDetailPage',
  File = 'File',
}